import builderHeaderBlock from '@components/ui-components/builder/header-block/component.js'
import textBlock from '@components/ui-components/builder/text/component.js'
import builderVideo from '@components/ui-components/builder/video/component.js'
import builderTimelineCases from '@components/ui-components/builder/timeline-cases/component.js'
import builderQuote from '@components/ui-components/builder/quote/component.js'
import builderSpeaker from '@components/ui-components/builder/speaker/component.js'
import builderGallery from '@components/ui-components/builder/gallery/component.js'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import builderWidget from '@components/ui-components/builder/widget/component.js'
import builderFullText from '@components/ui-components/builder/full-text/component.js'
import builderDoubleBlock from '@components/ui-components/builder/double-block/component.js'
import builderCardBlock from '@components/ui-components/builder/card-block/component.js'
import builderIconBlock from '@components/ui-components/builder/icon-block/component.js'
import builderList from '@components/ui-components/builder/list/component.js'
import builderLiteSliderBlock from '@components/ui-components/builder/lite-slider-block/component.js'
import builderBlueBlockItems from '@components/ui-components/builder/blue-block-items/component'
import builderBlueSliderBlockItems from '@components/ui-components/builder/blue-slider-block-items/component'
import builderInnerHtmlWidget from '@components/ui-components/builder/inner-html-widget/component.js'

export default {
  components: {
    'builder-header-block': builderHeaderBlock, // Заголовок
    'builder-text': textBlock, //Текст
    'builder-video': builderVideo, // Видео
    'builder-timeline-cases': builderTimelineCases, // Описание кейса
    'builder-quote': builderQuote, // Цитата
    'builder-speaker': builderSpeaker, // Спикер
    'builder-gallery': builderGallery, //Галлерея
    'page-form-cmp': PageForm, // Форма обратной связи
    'builder-widget': builderWidget, // Виджет
    'builder-full-text': builderFullText, // Текст + картинка
    'builder-double-block': builderDoubleBlock, // Двойной блок
    'builder-card-block': builderCardBlock, // Блок с карточками
    'builder-icon-block': builderIconBlock, // Блок с иконками
    'builder-list': builderList, // Список
    'builder-lite-slider-block': builderLiteSliderBlock, // Блок слайдера со списком
    'builder-blue-block-items': builderBlueBlockItems, // Синий блок с карточками
    'builder-blue-slider-block-items': builderBlueSliderBlockItems, // Синий блок со списками
    'builder-inner-html-widget': builderInnerHtmlWidget, // HTML-код виджет
  },
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/constructor/component.js